import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import Box from "@mui/system/Box";
import Typography from "@mui/material/Typography";
import StyledModal from "../../Modals/StyledModal/StyledModal";
import PrimaryButton from "../../Buttons/PrimaryButton/PrimaryButton";
import SecondaryButton from "../../Buttons/SecondaryButton/SecondaryButton";
import { SecurityService } from "../../../services/SecurityService";
import { ActiveUserContext, AlertContext } from "../../Dashboard/Dashboard";
import { handleAltEnter } from "../../../utils/keyboardShortcutHelpers";

export default function RegionsChangeUserRegionModal({
  openModal,
  handleCloseModal,
  user,
  originRegion,
  destinationRegion
}) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(openModal);
  const activeUser = useContext(ActiveUserContext);

  const handleSave = () => {
    setIsLoading(true);
    user.regionId = destinationRegion.regionId;

    SecurityService.UpdateRegionUser(instance, activeUser, user).then(() => {
      setIsLoading(false);
      handleCloseModal();
    }).catch(error => {
      console.error(error);
      warning(error);
    });
  };

  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);

  return (
    <Box onKeyDown={(e) => handleAltEnter(e, isLoading, handleSave)}>
      <StyledModal
        label={"Region Change"}
        title={"Region Change"}
        open={open}
        handleClose={handleCloseModal}
      >
        <Box sx={{ display: "flex" }}>
          <Box sx={{ marginRight: "60px" }}>
            <Typography variant="h3" sx={{ margin: "0 20px 20px 20px", color: "primary.60" }}>
              {user.userName}
            </Typography>
            <Typography sx={{ margin: "5px 20px", color: "black_solid.50" }}>
              will move from
            </Typography>
            <Box sx={{ display: "flex inline-flex" }}>
              <Typography sx={{ margin: "5px 20px" }}>
                {originRegion.regionName}
              </Typography>
              <Typography sx={{ margin: "5px 20px", color: "black_solid.50" }}>
                to
              </Typography>
              <Typography sx={{ margin: "5px 20px" }}>
                {destinationRegion.regionName}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: "flex", marginTop: "30px" }}>
          <Box sx={{ marginLeft: "auto", marginRight: "20px" }}>
            <SecondaryButton
              label="Cancel"
              onClick={handleCloseModal}
              disabled={isLoading}
            />
          </Box>
          <PrimaryButton
            label="Confirm"
            width="64px"
            onClick={handleSave}
            isLoading={isLoading}
            disabled={isLoading}
          />
        </Box>
      </StyledModal>
    </Box>
  );
}

RegionsChangeUserRegionModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  originRegion: PropTypes.object.isRequired,
  destinationRegion: PropTypes.object.isRequired
};